<template>
  <v-autocomplete
    :model-value="modelValue ?? value"
    :items="currencies"
    label="Currency"
    v-bind="$attrs"
    @update:model-value="onUpdate"
  >
    <template #progress>
      <v-progress-circular
        class="ma-auto"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </template>
  </v-autocomplete>
</template>

<script>
import { CURRENCY_OPTIONS } from '@/utils/currencies';

export default {
  name: 'BaseCurrencyPicker',

  inheritAttrs: false,

  props: {
    modelValue: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: '',
    },
  },

  emits: ['update:modelValue', 'input', 'change'],

  data: () => ({
    currencies: CURRENCY_OPTIONS,
  }),

  methods: {
    onUpdate(event) {
      this.$emit('update:modelValue', event);
      this.$emit('input', event);
      this.$emit('change', event);
    },
  },
};
</script>
